import { actingAsDisplay, useSession } from '@/app/session';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useDemoDoctors } from './UserMenu';

/**
 * Demo only. Rendered when the session is a presenter, the server honoured
 * an acting-as value for this tab, and the flag is on. States attribution
 * honestly on the projector without competing with the queue.
 */
export function ActingAsBanner() {
  const { me, setActingAs } = useSession();
  const show = Boolean(me && me.presenter && me.demoActingAs && me.actingAs);
  const doctors = useDemoDoctors(show);
  if (!me || !show) return null;
  const label = actingAsDisplay(me.actingAsName, me.actingAs) ?? me.actingAs;
  return (
    <div role="region" aria-label="Presenter mode" data-slot="acting-as-banner" className="bg-beam-warning-bg text-beam-warning">
      <div className="mx-auto flex min-h-9 max-w-[1448px] items-center justify-between gap-3 px-4 py-1 text-[13px] md:px-6">
        <p aria-live="polite" className="font-medium">
          <span className="md:hidden">Acting as {label}</span>
          <span className="hidden md:inline">Presenter acting as {label}. Every action is recorded as {me.name} acting as {label}.</span>
        </p>
        <div className="flex shrink-0 items-center gap-2">
          <Select value={me.actingAs ?? ''} onValueChange={(v) => setActingAs(v === 'self' ? null : v)}>
            <SelectTrigger size="sm" aria-label="Change who the presenter acts as" className="h-11 border-beam-warning/40 bg-beam-paper text-foreground md:h-7">
              <SelectValue placeholder="Change" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="self">Yourself</SelectItem>
              <SelectItem value="qa">QA</SelectItem>
              {(doctors.data ?? []).map((d) => (
                <SelectItem key={d.slug} value={`doctor:${d.slug}`}>{d.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button variant="ghost" size="sm" className="h-11 text-beam-warning hover:bg-beam-warning/10 md:h-7" onClick={() => setActingAs(null)}>
            Stop acting as
          </Button>
        </div>
      </div>
    </div>
  );
}
